import React from 'react'
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { localizer } from '../../Translator'

import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import InputAdornment from '@material-ui/core/InputAdornment'
import Backdrop from '@material-ui/core/Backdrop'

import { TextFieldStyled } from "../common/InputStyled"

import { SnackbarCustom } from "../Utilities/SnackbarCustom"

import AuthCli from '../../sdk/AuthCli'


/**
 * User credentials creation as a result of an invitation
 * sent to the e-mail address and navigated into this sign up
 * screen of the application.
 */
class InvitationSignup extends React.Component {

  constructor(props) {
    super(props)
    this.state = {

      // E-mail address that received the invitation, to be the user unique identifier.
      invitedEmail: props.invitedEmail,

      // Invitation token to be extracted from the URL query section.
      invitedToken: props.invitedToken,

      // Controlled form field.
      newPassword: '',

      // Controlled form field.
      newPasswordRepeat: '',

      // Indicates that the currently typed password would be accepted by the service (determined externally).
      isPasswordValid: false,

      // Failure message as received from the service on sign up error.
      errorFromService: null,

      // Flag waiting for server response.
      isLoading: false
    }

    // Make sure the focus is on the password text field initially.
    this.initialFocus = true
  }

  /**
   * Takes the query parameters where the invitation token and invited e-mail address are.
   * Also taken the password validity result from the password strength component.
   */
  async componentDidUpdate(prevProps) {
    if (prevProps === this.props) return
  
    this.setState({
      invitedEmail: this.props.invitedEmail,
      invitedToken: this.props.invitedToken,
      isPasswordValid: this.props.isPasswordValid
    })
  }

  /**
  * Controlled fields refresh.
  */
  handleFieldChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState((prev) => ({
      [name]: value
    }))
  }

  /**
   * Determines whether the currently typed in passwords are equal and not empty.
   */
  areTypedPasswordsEqualAndExisting = () => {
    if (this.state.newPassword === null || this.state.newPassword.length === 0) return false
    if (this.state.newPasswordRepeat === null || this.state.newPasswordRepeat.length === 0) return false
    if (this.state.newPassword !== this.state.newPasswordRepeat) return false
    return true
  }

  /**
   * Attempts to sign up the new user against the auth service using the
   * invitation token and the typed in password.
   */
  handleSignupRequest = (event) => {
    this.setState({ isLoading: true })
    this.setState({ errorFromService: null })
    AuthCli.SignUp({
      userEmail: this.state.invitedEmail,
      userPassword: this.state.newPassword,
      invitationToken: this.state.invitedToken
    }).then(async (error) => {
      if (typeof error === 'undefined') return
      if (error !== null) {
        // Error received from the service attempting to sign up.
        this.setState({ errorFromService: error.substring(error.indexOf(' ')) })
        this.setState({ isLoading: false })
      } else {
        // Clean up form.
        this.setState({ userEmail: '' })
        this.setState({ userPassword: '' })
        this.setState({ isLoading: false })

        // Redirecting to login screen.
        this.props.history.push("login");
      }
    }).catch(error => {
      this.setState({ errorFromService: localizer.CommsError + ": " + error.toString() })
      this.setState({ isLoading: false })
    })
  }

  handleonClose = () => {
    this.setState({ storeShipmentError: null})
  }
  
  render() {
    const isLoading = this.state.isLoading
    const mismatch = this.state.newPassword && this.state.newPasswordRepeat && this.state.newPassword !== this.state.newPasswordRepeat
    const invalid = !this.state.newPasswordRepeat || mismatch || !this.state.isPasswordValid

    return (
      <React.Fragment>

        <Paper elevation={2} >

          <Grid container spacing={4} style={{ paddingLeft: 18, paddingRight: 18 }}>
            <Grid item xs={12}>

              {/* E-mail address, user unique identifier for sign up. */}
              <TextFieldStyled
                variant="outlined"
                placeholder={localizer.YourLoginWillBe}
                value={this.state.invitedEmail}
                readOnly
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <i className="fa-solid fa-user"/>
                    </InputAdornment>
                  ),
                  classes: {
                    input:"typography-generic"
                  }
                }}
              />

            </Grid>
            <Grid item xs={12}>

              {/* New password, first typing. */}
              <TextFieldStyled
                variant="outlined"
                label={<Typography className="typography-generic textfield" variant="caption">{localizer.SignupPassword}</Typography>}
                placeholder={localizer.SignupPassword}
                name="newPassword"
                type="password"
                value={this.state.newPassword}
                onChange={(e) => { this.handleFieldChange(e); this.props.onPasswordChange(e.target.value) }}
                fullWidth
                inputRef={(input) => { if (input != null && this.initialFocus) { input.focus(); this.initialFocus = false }}}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <i className="fa-solid fa-key"></i>
                    </InputAdornment>
                  ),
                  classes: {
                    input:"typography-generic"
                  }
                }}
              />

            </Grid>
            <Grid item xs={12}>

              {/* New password, repeated. */}
              <TextFieldStyled
                error={mismatch || null}
                helperText={<Typography className="typography-generic textfield" variant="caption">{mismatch ? localizer.PasswordsMismatch : " "}</Typography>}
                variant="outlined"
                label={<Typography className="typography-generic textfield" variant="caption">{localizer.SignupPasswordRepeat}</Typography>}
                placeholder={localizer.SignupPassword}
                name="newPasswordRepeat"
                type="password"
                value={this.state.newPasswordRepeat}
                onChange={this.handleFieldChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <i className="fa-solid fa-key"></i>
                    </InputAdornment>
                  ),
                  classes: {
                    input:"typography-generic"
                  }
                }}
              />

            </Grid>
            <Grid item xs={12}>

              {/* Confirmation button. */}
              <Button
                className="button-generic"
                variant="contained"
                color="secondary"
                fullWidth
                disabled={isLoading || invalid}
                onClick={this.handleSignupRequest}>{localizer.Signup}
              </Button>

              <Typography className="typography-generic" variant="caption" display="block" gutterBottom style={{ marginTop: 10 }}>
                {localizer.formatString(localizer.OnSignupAcceptTerms, <Link className="link-without-underline" to="/conditions" target="_blank">{localizer.UseConditions}</Link>, <Link className="link-without-underline" to="/privacy" target="_blank">{localizer.PrivacyPolicy}</Link>)}
              </Typography>

            </Grid>
          </Grid>

        </Paper>

        {/* Waiting for service response. */}
        {isLoading &&
          <Backdrop open={isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }

        {/* Error on sign up attempt. */}
        <SnackbarCustom message={this.state.errorFromService} severity="error" handleonClose={this.handleonClose}/>
       
      </React.Fragment>
    )
  }
}

// Required to make history work.
export default withRouter(InvitationSignup);


// WEBPACK FOOTER //
// ./src/components/signup/InvitationSignup.js